import {
  CheckCircleIcon,
  ExclamationCircleIcon,
  CursorArrowRaysIcon,
} from "@heroicons/react/20/solid"
import Spin from "images/spin.svg"

export const SubmitButton = ({
  label,
  isSubmitSuccessful,
  isSubmitting,
  isSubmitError,
  errorMessage,
}) => {
  return (
    <div className="flex w-full items-start space-x-4">
      <button
        type="submit"
        className="relative rounded-lg bg-zinc-800 px-4 py-2 transition-all active:bg-kkm-darkgreen"
        id="registration-end"
      >
        {isSubmitting ? (
          <Spin className="absolute -ml-1 mt-0.5 h-5 w-5 animate-spin text-white" />
        ) : null}
        {!isSubmitting && !isSubmitError && !isSubmitSuccessful ? (
          <CursorArrowRaysIcon className="absolute -ml-1 mt-0.5 h-5 w-5 text-white" />
        ) : null}
        {isSubmitSuccessful && !isSubmitError && !isSubmitting ? (
          <CheckCircleIcon className="absolute -ml-1 mt-0.5 h-5 w-5 text-kkm-green" />
        ) : null}
        {isSubmitError && !isSubmitting ? (
          <ExclamationCircleIcon className="absolute -ml-1 mt-0.5 h-5 w-5 text-red-500" />
        ) : null}
        <div className="pl-6 font-bold text-white">{label}</div>
      </button>
      {isSubmitError && errorMessage ? (
        <div className="form-error-message text-sm text-red-500">
          {errorMessage}
        </div>
      ) : null}
    </div>
  )
}
